import ActiveIcon from "Resources/Images/TssIcons/ActiveDetector.png";
import SelectedActiveIcon from "Resources/Images/TssIcons/SelectedActiveDetector.png";
import ErrorIcon from "Resources/Images/TssIcons/ErrorDetector.png";
import SelectedErrorIcon from "Resources/Images/TssIcons/SelectedErrorDetector.png";
import FailedIcon from "Resources/Images/TssIcons/FailedDetector.png";
import SelectedFailedIcon from "Resources/Images/TssIcons/SelectedFailedDetector.png";
import OutOfServiceIcon from "Resources/Images/TssIcons/OosDetector.png";
import SelectedOutOfServiceIcon from "Resources/Images/TssIcons/SelectedOosDetector.png";
import { OpStatus } from "NSwag/ServerClient/Client.nswag";

/**
 * Maps all OpStatus enum values to their associated
 * detector icon.
 */
type IIconMap = Map<OpStatus, { unselected: any, selected: any }>;

/**
 * Maps all OpStatus enum values to their associated
 * detector icon.
 */
const detectorIconMapping: IIconMap = new Map<OpStatus, { unselected: any, selected: any }>([
    [OpStatus.NULL, {
        unselected: OutOfServiceIcon,
        selected: SelectedOutOfServiceIcon
    }],
    [OpStatus.NotSet, {
        unselected: OutOfServiceIcon,
        selected: SelectedOutOfServiceIcon
    }],
    [OpStatus.Active, {
        unselected: ActiveIcon,
        selected: SelectedActiveIcon
    }],
    [OpStatus.Error, {
        unselected: OutOfServiceIcon,
        selected: SelectedOutOfServiceIcon
    }],
    [OpStatus.Failed, {
        unselected: OutOfServiceIcon,
        selected: SelectedOutOfServiceIcon
    }],
    [OpStatus.OutOfService, {
        unselected: OutOfServiceIcon,
        selected: SelectedOutOfServiceIcon
    }]
]);

/**
 * Takes in an OpStatus for a detector and returns the associated icon
 * @param {any} opStatus
 */
export const getDetectorIcon = (opStatus: OpStatus, selected = false): string => {
    let icons = detectorIconMapping.get(opStatus);

    if (icons == null) {
        icons = detectorIconMapping.get(OpStatus.NULL);
    }
    return selected ? icons!.selected : icons!.unselected;
}